import { useCallback, useState } from 'react';
import { openSidePanel } from '@alfa-bank/newclick-core/window-utils';
import { ChatOptions } from '@alfa-bank/newclick-types/open-side-panel-params/options/chat';

import { useVoip } from '#/src/shared/components/voip/hooks/use-voip';
import { useAppSelector } from '#/src/shared/hooks';
import factoryFetch from '#/src/shared/lib/fetch-factory';
import { getSettingsState } from '#/src/shared/store/redux/setting/selectors';

const voipDeeplink = '/universal_support_call';

export const useChat = () => {
    const { openVoip } = useVoip();

    const [chatAuthSessionId, setChatSessionId] = useState<string>();

    const settings = useAppSelector(getSettingsState);

    const getSession = factoryFetch(settings.chat.AUTH_SESSION);

    const onSetChatSessionId = (session?: string) => {
        setChatSessionId(session);
    };

    const openDeeplink = useCallback(
        (arg?: string) => {
            if (arg === voipDeeplink) {
                openVoip({ view: 'voip', immediatelyStartCall: true });
            }
        },
        [openVoip],
    );

    const openChat = useCallback(() => {
        window.handleDeepLink = openDeeplink;
        getSession()
            .then((data) => {
                onSetChatSessionId(data.sessionId);

                return data.sessionId;
            })
            .then((sessionId) => {
                openSidePanel({ sidePanelId: 'Chat', options: { sessionId } as ChatOptions });
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openDeeplink]);

    return {
        chatAuthSessionId,
        onSetChatSessionId,
        openChat,
    };
};
